/** Generated citations may navigate to lessons or ordinary web sources, never script/data URLs. */
export function safeSourceUrl(source: string): string | undefined {
  if (/^\/(?:studio|workshop)\//.test(source) && !source.includes('\\')) return source;
  try {
    const url = new URL(source);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : undefined;
  } catch {
    return undefined;
  }
}

/** Mermaid additionally runs in strict mode. Reject directives, HTML and remotely loaded assets. */
export function isSafeDiagram(source: string) {
  return isSafeMioDiagram(source);
}
import { isSafeMioDiagram } from '@mio/shared';
